/**
 * Gespeicherte Feld-Rezepte des Workspace (Vorlage je Channel×Texttyp) —
 * Prefill für den Kanal-Akkordeon in Schritt 2 (Spec 2026-07-24 §3).
 */

import { useQuery } from '@tanstack/react-query'

import { getFieldRecipes } from '@/lib/api/channel-content-field-recipes'

export const fieldRecipesQueryKey = ['channelContentFieldRecipes'] as const

export function useFieldRecipes() {
  return useQuery({
    queryKey: fieldRecipesQueryKey,
    queryFn: () => getFieldRecipes(),
    select: (data) => data.recipes,
  })
}
